<div class="card-base">
    <mat-progress-bar class="progress-margin" color="primary" *ngIf="loading" mode="indeterminate">
    </mat-progress-bar>
    <div class="reminder-content-container">
        <div class="card-container mat-elevation-z1">
            <div class="content">
                <div class="card-inline div-header">
                    <div class="card-inline">
                        <h4>Recordatorio</h4>
                    </div>

                    <div class="card-inline">
                        <button (click)="sendMail()" mat-icon-button mat-mini-fab>
            <mat-icon>mail_outline</mat-icon>
          </button>
                    </div>
                </div>
                <div class="card-inline div-header-action">
                    <button mat-icon-button [matMenuTriggerFor]="menu">
                  <mat-icon>more_vert</mat-icon>
        </button>
                    <mat-menu #menu="matMenu">
                        <button (click)="printReminder()" mat-menu-item>
            <mat-icon>print</mat-icon>
            <span>Imprimir</span>
          </button>

                    </mat-menu>
                </div>
                <mat-divider></mat-divider>
                <div>

                    <!-- <img [src]='reminder.CenterLogoSafeUrl' /> -->
                    <div [innerHTML]="reminder.ReminderText"></div>

                </div>
            </div>
            <div class="card-footer margin-top-medium">
                <button color="primary" mat-flat-button (click)="finish()">Volver</button>
            </div>
        </div>
    </div>
</div>



<!-- <div class="card-base">
  <div class="card-content-reminder">
    <mat-progress-bar class="progress-margin"
                      color="primary"
                      *ngIf="loading"
                      mode="indeterminate">
    </mat-progress-bar>
    <div class="card-container mat-elevation-z1">
      <div class="card-content">
        <div class="card-inline div-header">
          <div class="card-inline">
            <h4>Recordatorio</h4>
          </div>
          <div class="card-inline">
            <button matTooltip="Enviar mail" (click)="sendMail()" mat-icon-button mat-mini-fab>
              <mat-icon>mail_outline</mat-icon>
            </button>
          </div>
        </div>
        <mat-divider></mat-divider>
        <div class="margin-top-medium reminder-text-container">
          <div>
            <img [src]='reminder.CenterLogoSafeUrl' />
            <div [innerHTML]="reminder.ReminderText"></div>
          </div>
        </div>
      </div>
      <div class="card-footer margin-top-medium">
        <button color="primary" mat-flat-button (click)="finish()">Volver</button>
      </div>
    </div>
  </div>
</div> -->
